export default "__VITE_ASSET__19758967__"